(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sz-diagnostic-quiz"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-quiz]');
    if (!root) return;

    // ---------- Données ----------
    var products = [];
    try {
      products = JSON.parse(root.querySelector('[data-quiz-products]').textContent).filter(Boolean);
    } catch (e) {
      products = [];
    }

    var moneyFormat = '';
    try {
      moneyFormat = JSON.parse(root.querySelector('[data-quiz-money]').textContent) || moneyFormat;
    } catch (e) {}

    // Quels tags comptent pour chaque réponse
    var SKIN = {
      seche: ['peau-seche', 'peau-deshydratee'],
      grasse: ['peau-grasse', 'peau-a-imperfections', 'imperfections'],
      normale: ['peau-normale'],
      sensible: ['peau-sensible', 'barriere-cutanee', 'sans-parfum', 'test-dermatologique']
    };
    var PRIORITY = {
      hydratation: ['hydratant', 'acide-hyaluronique', 'peau-deshydratee', 'barriere-cutanee'],
      imperfections: ['imperfections', 'peau-a-imperfections', 'purifiant', 'niacinamide'],
      antiage: ['anti-age', 'peptides', 'alternative-retinol', 'peau-mature'],
      taches: ['taches-pigmentaires', 'teint-irregulier', 'alpha-arbutine', 'niacinamide']
    };

    var SKIN_LABEL = {
      seche: 'peau sèche',
      grasse: 'peau grasse ou à imperfections',
      normale: 'peau normale',
      sensible: 'peau sensible'
    };
    var PRIORITY_LABEL = {
      hydratation: 'hydratation',
      imperfections: 'imperfections',
      antiage: 'rides et fatigue',
      taches: 'teint et taches'
    };
    var STEP_LABEL = { 1: 'Étape 01 — Nettoyer', 2: 'Étape 02 — Hydrater', 3: 'Étape 03 — Cibler' };

    var answers = {};
    var order = ['skin', 'priority', 'time', 'result'];
    var steps = root.querySelectorAll('[data-quiz-step]');
    var bar = root.querySelector('[data-quiz-bar]');
    var routine = [];

    function countMatches(tags, list) {
      var n = 0;
      list.forEach(function (t) {
        if (tags.indexOf(t) !== -1) n++;
      });
      return n;
    }

    function score(product) {
      var s = 0;
      var tags = product.tags || [];
      var skinTags = SKIN[answers.skin] || [];
      var prioTags = PRIORITY[answers.priority] || [];
      s += countMatches(tags, skinTags) * 3;
      // La priorité compte double pour le sérum (étape 03)
      s += countMatches(tags, prioTags) * (product.step === 3 ? 6 : 3);
      if (tags.indexOf('tous-types-de-peau') !== -1) s += 1;
      // Peau sensible : éviter les soins purifiants
      if (answers.skin === 'sensible' && tags.indexOf('purifiant') !== -1) s -= 3;
      return s;
    }

    function best(step) {
      var list = products.filter(function (p) {
        return p.step === step;
      });
      if (!list.length) return null;
      list.sort(function (a, b) {
        return score(b) - score(a) || a.price - b.price;
      });
      return list[0];
    }

    function money(cents) {
      var value = (cents / 100).toFixed(2);
      var comma = value.replace('.', ',');
      if (!moneyFormat) return comma + ' €';
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
        .replace(/\{\{\s*amount\s*\}\}/, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/<[^>]*>/g, '');
    }

    function why(product) {
      var reasons = [];
      var tags = product.tags || [];
      if (countMatches(tags, SKIN[answers.skin] || []) > 0) reasons.push(SKIN_LABEL[answers.skin]);
      if (countMatches(tags, PRIORITY[answers.priority] || []) > 0) reasons.push(PRIORITY_LABEL[answers.priority]);
      if (!reasons.length && tags.indexOf('tous-types-de-peau') !== -1) reasons.push('tous types de peau');
      return reasons.length ? 'Choisi pour : ' + reasons.join(' · ') : '';
    }

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text == null ? '' : String(text);
      return div.innerHTML;
    }

    function show(name) {
      steps.forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-quiz-step') === name);
      });
      var index = order.indexOf(name);
      bar.style.width = ((index + 1) / order.length) * 100 + '%';
      var top = root.getBoundingClientRect().top + window.scrollY - 120;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function renderResult() {
      var wanted = answers.time === 'essentiel' ? [1, 2] : [1, 2, 3];
      routine = wanted.map(best).filter(Boolean);

      root.querySelector('[data-quiz-result-title]').innerHTML =
        'Votre routine <em>' + (answers.time === 'essentiel' ? 'essentielle.' : 'complète.') + '</em>';
      root.querySelector('[data-quiz-result-text]').textContent =
        'Pour une ' + SKIN_LABEL[answers.skin] + ', avec une priorité ' + PRIORITY_LABEL[answers.priority] +
        ' : ' + routine.length + ' soins, dans l’ordre où les appliquer.';

      var list = root.querySelector('[data-quiz-routine]');
      list.innerHTML = routine
        .map(function (p) {
          return (
            '<li class="sz-quiz__item">' +
            '<a class="sz-quiz__item-media" href="' + escapeHtml(p.url) + '">' +
            (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div><span class="sz-quiz__item-step">' + STEP_LABEL[p.step] + '</span>' +
            '<a class="sz-quiz__item-title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
            '<p class="sz-quiz__item-why">' + escapeHtml(why(p)) + '</p></div>' +
            '<span class="sz-quiz__item-price">' + escapeHtml(p.price_label) + '</span>' +
            '</li>'
          );
        })
        .join('');

      var total = routine.reduce(function (sum, p) {
        return sum + p.price;
      }, 0);
      root.querySelector('[data-quiz-total]').textContent = money(total);
      root.querySelector('[data-quiz-add]').disabled = routine.length === 0;
      root.querySelector('[data-quiz-error]').hidden = true;
    }

    // ---------- Interactions ----------
    root.addEventListener('click', function (event) {
      var option = event.target.closest('.sz-quiz__options button');
      if (option) {
        var step = option.closest('[data-quiz-step]');
        var key = step.getAttribute('data-quiz-step');
        step.querySelectorAll('button').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        option.classList.add('is-selected');
        answers[key] = option.getAttribute('data-value');
        var next = order[order.indexOf(key) + 1];
        if (next === 'result') renderResult();
        setTimeout(function () {
          show(next);
        }, 180);
        return;
      }

      if (event.target.closest('[data-quiz-back]')) {
        var current = event.target.closest('[data-quiz-step]').getAttribute('data-quiz-step');
        show(order[Math.max(0, order.indexOf(current) - 1)]);
        return;
      }

      if (event.target.closest('[data-quiz-restart]')) {
        answers = {};
        root.querySelectorAll('.is-selected').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        show('skin');
        return;
      }

      var addButton = event.target.closest('[data-quiz-add]');
      if (addButton && routine.length) {
        addButton.disabled = true;
        addButton.textContent = 'Ajout en cours…';
        fetch(root.getAttribute('data-cart-add-url'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: routine.map(function (p) {
              return { id: p.id, quantity: 1 };
            })
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart');
            window.location.href = root.getAttribute('data-cart-url');
          })
          .catch(function () {
            addButton.disabled = false;
            addButton.textContent = 'Ajouter ma routine au panier';
            root.querySelector('[data-quiz-error]').hidden = false;
          });
      }
    });

    show('skin');
  })();
  } catch(e) { console.error(e); }
})();

})();
